import { useState } from "react";
import { Reveal, SectionHead } from "./Reveal";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { GALLERY } from "../data/site";

export const Gallery = () => {
  const [active, setActive] = useState(null);
  if (!GALLERY.length) return null;

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#0A0A0A] px-6 py-24 md:px-12 md:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHead
          id="gallery"
          overline="On Site"
          title="Project Gallery"
          desc="Photos from our fabrication workshops, roofing installations and project sites across Hyderabad and Telangana."
        />

        <div className="mt-14 columns-1 gap-5 sm:columns-2 lg:columns-3">
          {GALLERY.map((g, i) => (
            <Reveal key={g.id} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(g)}
                className="group relative block w-full overflow-hidden border border-white/10 text-left"
              >
                <img
                  src={g.img}
                  alt={g.title || "Renuka Roofing Structurals project photo"}
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                {(g.title || g.desc) && (
                  <div className="absolute inset-x-0 bottom-0 p-5">
                    {g.title && (
                      <h3 className="font-display text-lg font-semibold tracking-tight">{g.title}</h3>
                    )}
                    {g.desc && (
                      <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-[#A3A3A3]">{g.desc}</p>
                    )}
                  </div>
                )}
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-3xl border-white/10 bg-[#0A0A0A] text-white" data-testid="gallery-modal">
          {active && (
            <>
              <div className="overflow-hidden bg-black">
                <img
                  src={active.img}
                  alt={active.title || "Project photo"}
                  className="max-h-[60vh] w-full object-contain"
                />
              </div>
              {active.title && (
                <DialogHeader>
                  <DialogTitle className="font-display text-2xl font-bold tracking-tight" data-testid="gallery-modal-title">
                    {active.title}
                  </DialogTitle>
                </DialogHeader>
              )}
              {active.desc && (
                <p className="text-sm leading-relaxed text-[#A3A3A3]">{active.desc}</p>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
